"use client";
import Links from "./units/Links";
import Logo from "./units/Logo";
import useSidebar from "./useSidebar";

function Sidebar({ mobile = false }: { mobile?: boolean }) {
  const { sidebarLinks } = useSidebar();

  return (
    <div
      className={`top-0 h-[100dvh] w-[244px] shrink-0 flex-col overflow-x-hidden overflow-y-auto border-e border-slate-100 bg-[#fcfcfe] shadow-[8px_0_30px_rgba(31,5,112,0.04)] ${
        mobile ? "flex w-full border-e-0 shadow-none" : "sticky hidden lg:flex"
      }`}
    >
      <Logo />
      <nav className="w-full flex-1 px-3 pb-6 pt-3">
        {sidebarLinks?.map((el, index) => (
          <div
            key={`${el.label}-${index}`}
            className="w-full border-b border-slate-100 py-3 last:border-b-0"
          >
            <p className="px-3 pb-2 pt-1 text-[11px] font-bold tracking-wide text-slate-400">
              {el.label}
            </p>
            <div className="space-y-1">
              {el?.data?.map((nel, nelIndex) => (
                <Links key={`${index}-${nelIndex}`} parent={nel} />
              ))}
            </div>
          </div>
        ))}
      </nav>
    </div>
  );
}

export default Sidebar;
